module.exports = __webpack_public_path__ + "8c53cceb6f43a263d9b75aebe96bf2ec.png";